import { isEmpty } from 'lodash-es';

import { ValueRightAxis } from '../../../core/components/axes/components/ValueRightAxis.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { AREAS } from '../../constants/histogram-grid-area-rules.js';
import { useHistogramTickAxis } from '../../hooks/useHistogramTickAxis.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';
import { useYAxisConfig } from '../../hooks/useYAxisConfig.js';

export const HistogramValueRightAxisArea = () => {
  const { right: axisRight } = useYAxisConfig();
  const [, yScale] = useHistogramYScales();

  const ticks = useHistogramTickAxis();
  const rightTicks = ticks?.right || { ticks: [], formattedTicks: [] };

  if (isEmpty(rightTicks.ticks) || !yScale) {
    return null;
  }

  return (
    <ChartGrid.GridArea gridArea={AREAS.rightAxis}>
      {({ availableWidth, availableHeight }) => {
        return (
          <ValueRightAxis
            ticks={rightTicks.ticks}
            formattedTicks={rightTicks.formattedTicks}
            containerHeight={availableHeight}
            containerWidth={availableWidth}
            scale={yScale}
            label={axisRight?.label}
          />
        );
      }}
    </ChartGrid.GridArea>
  );
};

HistogramValueRightAxisArea['displayName'] = 'HistogramValueRightAxisArea';
